import React, { Component } from "react";
import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

export class LSC_SigninReplace extends Component {
    static displayName = LSC_SigninReplace.name;

    constructor(props) {
        super(props);
        this.state = {
            message: "LSC_SigninReplace"
        };
    }

    componentDidMount() {
        //const links = [
        //    "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
        //    "/css/lsc/style_01.css",
        //    "/css/lsc/style_02.css",
        //    "/css/lsc/style_03.css",
        //    "/css/lsc/691208892_en-US.css",
        //    "/css/lsc/line_my_card.css"
        //];

        //links.forEach(href => {
        //    const link = document.createElement("link");
        //    link.rel = "stylesheet";
        //    link.href = href;
        //    document.head.appendChild(link);
        //});
    }

    render() {
        const {
            message
        } = this.state;

        return (
            <>
                <ZPartnerLSC0Header />

                <main id="main">
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">
                                        ยืนยันการใช้ Starbucks® Rewards บัญชีนี้กับ LINE My Card ใบใหม่<br />
                                        Confirm to link this Starbucks® Rewards account with new LINE My Card</h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <form className="form-sr px-1">
                                            <div className="mb-4 text-center">
                                                <p>บัญชี Starbucks® Rewards นี้ มีการใช้งาน LINE Starbucks Card  ที่ผูกกับบัญชี LINE อื่นอยู่แล้ว หากคุณต้องการเปลี่ยนบัญชี LINE  กรุณาตรวจสอบที่อีเมลของคุณ เพื่อทำการกดยืนยันอีกครั้ง</p>
                                                <p>This Starbucks<sup>®</sup> Rewards has been linked to the LINE Starbucks Card that is associated with another LINE account. If you want to change your LINE account, please check your email and click the link to verify.</p>
                                                <p>
                                                    <small>
                                                        หากไม่ได้รับอีเมล กรุณาตรวจสอบใน Spam Mail Box หรือ Junk Mail Box ของคุณ<br />
                                                        Please check your Spam or Junk folder to ensure the message was not filtered.
                                                    </small>
                                                </p>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <ZPartnerLSC0Footer />
            </>
        );
    }
}
